import React, { useEffect, useState } from 'react';
import {
  Box, Grid, LinearProgress, List, ListItem, Stack, Typography
} from '@mui/material';
import { ClassNameMap, withStyles } from '@mui/styles';
import stylesheet from '../detail-container.stylesheet';
import moment from 'moment';
import { toast } from 'react-toastify';
import Helper from '../../../../utils/helper';
import { TaskService } from '../../../tasks/tasks.service';


interface IProps {
  input: any,
  classes: ClassNameMap
}

const TaskBPDetailsComponent: React.FC<IProps> = ({ input, classes }) => {
  const [bpData, setBpData] = useState({}) as any
  const [loading, setLoading] = useState(false) as any

  const taskService = new TaskService();

  useEffect(() => {
    if (input?.id) {
      getBPDetails()
    }
  }, [input])

  const getBPDetails = () => {
    setLoading(true)
    taskService.getTaskBPDeatils(input.id).then((res: any) => {
      setBpData(res?.data || {})
      setLoading(false)
    }).catch((err: any) => {
      setLoading(false)
      toast.error(Helper.getError(err), Helper.bottom_center())
    })
  }

  const renderLogVal = () => {
    let data = {} as any
    Object.keys(bpData).map((i: any) => {
      if (!['SBP 4 day', 'DBP 4 day', 'SBP 10 day', 'DBP 10 day', 'SBP', 'DBP'].includes(i))
        data = ({ ...data, [i]: bpData[i] })
    })
    return <List className={classes.zeroPadding}>
      {Object.keys(data)?.map((i: any) =>
        <Stack direction={'row'} spacing={0.4}>
          <Typography className={classes.evalBoxVal}>{i}</Typography>
          <Typography pl={0.5} className={classes.toxicityEvalBoxVal}>
            {JSON.stringify(!data[i] || data[i] === null ? false : data[i])}
          </Typography>
        </Stack>
      )}
    </List>
  }

  const renderBPVal = (title: any, val: any) => {
    return <Stack direction={'column'} className={classes.zeroTopPadding}>
      <Typography className={classes.evalBoxVal}>{title}</Typography>
      <Typography pl={0} className={classes.toxicityEvalBoxVal}>{val}</Typography>
    </Stack>
  }

  return (
    <Stack className={classes.taskNotesBox} direction={'column'} sx={{ margin: '0px -0.95rem !important' }}>
      {loading && <LinearProgress />}
      <Box sx={{ width: '10rem', padding: '0.5rem 0rem 0rem 0.7rem' }}>
        {!loading &&
          <Stack direction={'column'} spacing={0.1}>
            {renderBPVal(`BP 4 days`, `SBP: ${bpData['SBP 4 day']} DBP: ${bpData['DBP 4 day']}`)}
            {renderBPVal(`BP 10 days`, `SBP: ${bpData['SBP 10 day']} DBP: ${bpData['DBP 10 day']}`)}
            {renderBPVal(`BP recent`, `SBP: ${bpData['SBP']} DBP: ${bpData['DBP']}`)}
            <Box pt={0.25}>{renderLogVal()}</Box>
          </Stack>
        }
      </Box>
    </Stack>
  )
}

export default withStyles(stylesheet)(TaskBPDetailsComponent);